import { FULL_PAGE_NOTIFICATIONS_PAGE, FULL_PAGE_NOTIFICATIONS_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const notificationsRoute = createGlobalRoute({
	exact: true,
	layout: 'expanded',
	name: FULL_PAGE_NOTIFICATIONS_PAGE,
	path: FULL_PAGE_NOTIFICATIONS_PATH,
});
